export const HEADING_STYLES = {
  PRIMARY: 'primaryButton',
  SECONDARY: 'secondaryButton',
};
